
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TestIntro from './components/TestIntro';
import TestQuiz from './components/TestQuiz';
import TestResult from './components/TestResult';

const TestPage = () => {
  const [testStarted, setTestStarted] = useState(false);
  const [testCompleted, setTestCompleted] = useState(false);
  const [answers, setAnswers] = useState<Record<number, string | string[]>>({});

  const handleStartTest = () => {
    setTestStarted(true);
  };

  const handleCompleteTest = (finalAnswers: Record<number, string | string[]>) => {
    setAnswers(finalAnswers);
    setTestCompleted(true);
  };

  const handleRestartTest = () => {
    setTestStarted(false);
    setTestCompleted(false);
    setAnswers({});
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      <Navbar />
      <main className="pt-20">
        {!testStarted && !testCompleted && (
          <TestIntro onStart={handleStartTest} />
        )}
        {testStarted && !testCompleted && (
          <TestQuiz onComplete={handleCompleteTest} />
        )}
        {testCompleted && (
          <TestResult answers={answers} onRestart={handleRestartTest} />
        )}
      </main>
      <Footer />
    </div>
  );
};

export default TestPage;
